function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M9.114 2.452a8.346 8.346 0 014.88-.165 8.196 8.196 0 014.11 2.591 7.86 7.86 0 01.796 9.128 8.11 8.11 0 01-3.606 3.238 8.335 8.335 0 01-4.625.676l1.912 2.618c.12.226.15.487.086.733-.065.246-.22.462-.438.608a1.144 1.144 0 01-1.438-.143l-3.582-4.888a1.018 1.018 0 01-.177-.78c.05-.272.21-.514.445-.675l5.115-3.422a1.15 1.15 0 01.768-.082c.257.061.483.21.636.418a1.02 1.02 0 01-.15 1.375l.01.002-3.317 2.22c.08-.007.162-.004.244.01a6.338 6.338 0 003.677-.488 6.112 6.112 0 002.72-2.438 5.86 5.86 0 00-.598-6.813 6.196 6.196 0 00-3.108-1.957 6.347 6.347 0 00-3.71.126 6.162 6.162 0 00-2.96 2.161 1 1 0 01-1.609-1.187 8.162 8.162 0 013.919-2.866z",
  clipRule: "evenodd"
});

var SvgClockwise = function SvgClockwise(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default SvgClockwise;